import fetch from "@/plugin/axios"

//用户列表分页
export function page(query) {
  return fetch({
    url: "/admin/user/page",
    method: "get",
    params: query
  })
}

//用户列表
export function list(query) {
  return fetch({
    url: "/admin/user/list",
    method: "get",
    params: query
  })
}


export function saveAndUpdate(obj) {
  return fetch({
    url: "/admin/user/saveAndUpdate",
    method: "post",
    data: obj
  })
}

export function getObj(id){
  return fetch({
    url:"/admin/user/"+id,
    method: "get"
  })
}

export function statistics(query){
  return fetch({
    url:"/admin/user/statistics",
    method: "get",
    params:query
  })
}

export function classesList(){
  return fetch({
    url:"/admin/classes/all",
    method: "get",
  })
}

export function selectUserIntegral(obj){
  return fetch({
    url:"/admin/user/selectUserIntegral",
    method: "post",
    data: obj
  })
}